<template>
	<div class="tabWrapperSettings tabContactsTypes">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="contactsTypesContactsTypes"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new contact type"
				page-title="Contacts Types"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-contacts-types
				v-if="isViewContactsTypes"
				:dialogFlag="dialogFlag"
				:editContactsTypes="editContactsTypes"
				:items="contactsTypesContactsTypes"
				@updateSave="onSaveViewContactsTypes"
				@updateClose="onCloseDialog('isViewContactsTypes')"
				@updateList="onUpdateList('contactsTypes')"
		></view-contacts-types>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabContactsTypesTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewContactsTypes from "@/components/Settings/UserAccountSettings/ViewContactsTypes/ViewContactsTypes.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabContactsTypes",
	components: {
		DialogRemove,
		ViewContactsTypes,
		MainTable
	},
	computed: {
		...mapGetters([
			'editContactsTypes',
			'settingsContactsTypes',
			'contactsTypesContactsTypes',
			'filtersContactsTypes',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabContactsTypesTable;
		},
	},

	data: () => ({
		flag: TAB.CONTACTS_TYPES,

		isViewContactsTypes: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountContactsTypesList',
			'getAccountContactsTypesEdit',
			'deleteAccountContactsTypes',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_CONTACTS, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'contactsTypes') {
				await this.getAccountContactsTypesList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabContactsTypes' && key === 'edit1') {
				this.accountContactsTypesEdit();
			}
			if (nameComponent === 'tabContactsTypes' && key === 'delete1') {
				const title = TITLE.REMOVE_CONTACTS_TYPES;
				const text = TEXT.REMOVE_CONTACTS_TYPES;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabContactsTypes') {
				const { id } = this.activeItem;
				await this.deleteAccountContactsTypes(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountContactsTypesEdit() {
			const { id } = this.activeItem;
			await this.getAccountContactsTypesEdit(id);
			this.isViewContactsTypes = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewContactsTypes = true;
		},
		onSaveViewContactsTypes(args) {
			console.info('%c [ onSaveViewContactsTypes args  ] ', 'color:#bada55', typeof args, args );
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountContactsTypesList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

